var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card customer-chat border-0 mw-100 mr-2 v2026-qm-host"},[_c('div',{staticClass:"card-body"},[_c('QuotedMessageV2026',{attrs:{"quotedMessage":_vm.quotedMessage}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }